import { render } from "./categoriesMenu.vue?vue&type=template&id=ed07774c&scoped=true"
import script from "./categoriesMenu.vue?vue&type=script&lang=js"
export * from "./categoriesMenu.vue?vue&type=script&lang=js"

import "./categoriesMenu.vue?vue&type=style&index=0&id=ed07774c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed07774c"]])

export default __exports__